__turbopack_context__.v({
  "Cont": "TeamGrid-module-sass-module__Pk1MbG__Cont",
  "Copy": "TeamGrid-module-sass-module__Pk1MbG__Copy",
  "MobileRow": "TeamGrid-module-sass-module__Pk1MbG__MobileRow",
  "MobileSliders": "TeamGrid-module-sass-module__Pk1MbG__MobileSliders",
  "Row": "TeamGrid-module-sass-module__Pk1MbG__Row",
  "Select": "TeamGrid-module-sass-module__Pk1MbG__Select",
  "Slider": "TeamGrid-module-sass-module__Pk1MbG__Slider",
  "Style2": "TeamGrid-module-sass-module__Pk1MbG__Style2",
  "TeamGrid": "TeamGrid-module-sass-module__Pk1MbG__TeamGrid",
  "animate-in": "TeamGrid-module-sass-module__Pk1MbG__animate-in",
});
